<script lang="ts">
	import { slide } from 'svelte/transition';
	export let index: number;
	export let title: string;
	export let url: string;

	const getFaviconUrl = (url: string) => {
		const { hostname } = new URL(url);
		return `https://www.google.com/s2/favicons?domain=${hostname}`;
	};
	const getSiteTitle = (url: string) => {
		const { hostname } = new URL(url);
		return hostname;
	};

	const hostName = getSiteTitle(url);
	const favicon = getFaviconUrl(url);
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<a in:slide href={url} target="_blank">
	<div class="main-wrapper">
		<div class="top">
			{title ? title : `Source ${index + 1}`}
		</div>
		<div class="bottom">
			<img src={favicon} alt="" />
			<span>{hostName} · {index + 1}</span>
		</div>
	</div>
</a>

<style lang="scss">
	.main-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		width: 148px;
		min-width: 148px;
		height: 80px;
		background-color: var(--chat-input-bg);
		border: solid 1px var(--button-border-color);
		font-size: inherit;
		box-sizing: border-box;
		padding: 8px;
		border-radius: 6px;
		font-weight: 300;
		cursor: pointer;

		@media (hover: hover) {
			&:hover {
				filter: brightness(1.05);
			}
		}
	}
	.top {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: initial;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		line-height: 1.3;
	}
	.bottom {
		display: flex;
		gap: 4px;
		align-items: center;

		span {
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			color: var(--source-card-link-color);
		}

		img {
			width: 16px;
			height: 16px;
		}
	}
</style>
